<template>
  <div>
    <app-links />
  </div>
</template>

<script>
import AppLinks from "./platform-pages/app-links";
export default {
  components: { AppLinks },
  mounted() {
    setTimeout(() => {
      window.scrollTo({ top: 700, behavior: "smooth" });
    }, 500);
  },
};
</script>
